/** @jsx jsx */
import { jsx } from '@emotion/core';
import { React } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import { Icon } from '../../ui/Icon';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';
import { withNamespaces } from 'react-i18next';

import Slider from './Slider';

import DotComponent from '../../ui/DotComponent';
import { Container, Row } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';
import { get } from 'lodash';

class WhatWeDoTeaser extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;

    // fields.Title.value
    const Title = get(fields, 'WhatWeDoData.Title', '');
    const Speed = get(fields, 'Speed.value', '');
    const Delay = get(fields, 'Delay.value', '');
    const TopRightLink = get(fields, 'WhatWeDoData.TopRightLink', '');
    const TopRightText = get(fields, 'WhatWeDoData.TopRightLinkText', '');
    const Cards = get(fields, 'WhatWeDoData.Cards', []);

    return (
      <Spacer customCss={styles.whatwedoteaserbg}>
        <Container css={[styles.whatwedoteaser]}>
          <div className="headsec">
            <h2>
              {Title}
              <DotComponent />
            </h2>

            <div className="toprightviewsection">
              {TopRightText && (
                <a href={TopRightLink}>
                  <span>{TopRightText}</span>
                  <span>
                    <Icon name="chevron-right" />
                  </span>
                </a>
              )}
            </div>
          </div>
          {/* <Row> */}
          {Cards && (
            <Slider
              cards={[...Cards, ...Cards]}
              speed={Speed}
              delay={Delay}
              // cards={Cards}
            />
          )}
          {/* </Row> */}
        </Container>
      </Spacer>
    );
  }
}

WhatWeDoTeaser.displayName = 'WhatWeDoTeaser';

export default compose(withNamespaces(), withSitecoreContext())(WhatWeDoTeaser);
